export default (str: string) => {
  return str
    .normalize("NFD") // Decompose characters into base + combining characters
    .replace(/[\u0300-\u036f]/g, "") // Remove combining diacritical marks
    .replace(/[^\w\s]/g, "") // Remove any remaining special characters (optional)
    .toLowerCase();
};
